module.exports = __webpack_public_path__ + "static/media/NWIL-Booklet-A5-Nov 2022.9d06101b.pdf";